<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear cliente</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitClient">
                                <div class="row">
                                <div class="col-md-6">
                                    <label for="nit" class="form-control-label">Documento de identidad</label>
                                    <argon-input id="nit" type="text" v-model="client.nit" placeholder="NIT/Cédula/DUI" :disabled="!client.nit" />
                                    <small v-if="submitted && v$.client.nit.$error" class="text-danger">Documento de identidad (NIT) es requerido</small>
                                </div>

                                <div class="col-md-6">
                                    <label for="clientType" class="form-control-label">Tipo de cliente</label>
                                    <argon-select id="clientType" class="form-control" type="text" v-model="client.type" :choices="clientTypes"/>
                                    <small v-if="submitted && v$.client.type.$error" class="text-danger">Tipo de cliente es requerido</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="documentType" class="form-control-label">Tipo Documento</label>
                                    <argon-select id="documentType" class="form-control" type="text" v-model="client.document_type" :choices="documentTypes"/>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="nrc" class="form-control-label">NRC (Reg. Contribuyente)</label>
                                    <argon-input id="nrc" type="text" v-model="client.nrc" placeholder="NRC (Obligatorio para Jurídica)" />
                                    <!-- <small v-if="submitted && v$.client.nrc.$error" class="text-danger">NRC es requerido para este tipo de cliente</small> -->
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label for="nrc" class="form-control-label">Tipo de Contribuyente</label>
                                    <argon-select id="retentionCategories" class="form-control" type="text" v-model="client.retention_category" :choices="retentionCategories"/>
                                    <!-- <small v-if="submitted && v$.client.nrc.$error" class="text-danger">NRC es requerido para este tipo de cliente</small> -->
                                </div>
                                <div class="col-md-6 mt-3" v-if="client.type == 'JURIDICA'">

                                </div>

                                <div class="col-md-12 mt-3">
                                    <label for="clientName" class="form-control-label">Nombres y Apellidos / Razón Social</label>
                                    <argon-input id="clientName" type="text" v-model="client.name" />
                                    <small v-if="submitted && v$.client.name.$error" class="text-danger">Nombre es requerido</small>
                                </div>

                                <div class="col-md-12" v-if="client.type === 'JURIDICA'">
                                    <label for="businessName" class="form-control-label">Nombre Comercial / Razón Social</label>
                                    <argon-input id="businessName" type="text" v-model="client.business_name" placeholder="Razón Social (Opcional)" />
                                </div>

                                <div class="col-md-12 mt-3" v-if="client.type !== 'EXCENT'">
                                    <label for="activityCode" class="form-control-label">Actividad Económica</label>
                                    <ArgonLookup
                                        id="activityCode"
                                        :options="economicActivities"
                                        v-model="client.activity_code_object" display-key="text" track-by="value"     placeholder="Escriba el código o descripción de la actividad..."
                                        @update:modelValue="handleActivityLookupChange" >
                                        <template #option="{ option }">
                                            <div class="d-flex flex-column w-100">
                                                <span class="font-weight-bold text-sm">{{ option.value }}</span>
                                                <span class="text-xs text-muted">{{ option.description }}</span>
                                            </div>
                                        </template>
                                    </ArgonLookup>

                                    <small class="text-muted" v-if="client.activity_desc">Desc.: {{ client.activity_desc }}</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="department" class="form-control-label">Departamento</label>
                                    <ArgonLookup
                                        id="department"
                                        :options="locations.departments"
                                        v-model="client.department_object"
                                        display-key="text"
                                        track-by="value"
                                        placeholder="Escriba el departamento..."
                                        @update:modelValue="handleDepartmentLookupChange" >
                                        <template #option="{ option }">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <span class="font-weight-bold">{{ option.text }}</span>
                                                <span class="text-sm text-muted">Códdigo: {{ option.code }}</span>
                                            </div>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="submitted && v$.client.department.$error" class="text-danger">Departamento es requerido</small>
                                    <small class="text-muted" v-if="client.department_code">Código: {{ client.department_code }}</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="municipality" class="form-control-label">Municipio</label>
                                    <ArgonLookup
                                        id="municipality"
                                        :options="locations.municipalities"
                                        v-model="client.municipality_object"
                                        display-key="text"
                                        track-by="value"
                                        placeholder="Escriba el municipio..."
                                        @update:modelValue="handleMunicipalityLookupChange" >
                                        <template #option="{ option }">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <span class="font-weight-bold">{{ option.text }}</span>
                                                <span class="text-sm text-muted">Código: {{ option.code }}</span>
                                            </div>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="submitted && v$.client.municipality.$error" class="text-danger">Municipio es requerido</small>
                                    <small class="text-muted" v-if="client.municipality_code">Código: {{ client.municipality_code }}</small>
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label for="fiscalAddress" class="form-control-label">Dirección Fiscal</label>
                                    <argon-textarea id="fiscalAddress" type="text" v-model="client.fiscal_address"/>
                                    <small v-if="submitted && v$.client.fiscal_address.$error" class="text-danger">Dirección Fiscal es requerida</small>
                                </div>

                                <div class="col-md-12">
                                    <label for="commercialAddress" class="form-control-label">Dirección Comercial (Si es diferente)</label>
                                    <argon-textarea id="commercialAddress" type="text" v-model="client.commercial_address"/>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="phone" class="form-control-label">Teléfono</label>
                                    <argon-input id="phone" type="text" v-model="client.phone" />
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label for="email" class="form-control-label">Correo</label>
                                    <argon-input id="email" type="text" v-model="client.email" />
                                    <small v-if="submitted && v$.client.email.$error" class="text-danger">Correo electrónico inválido</small>
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label class="form-control-label">Archivos (Documentos y Foto)</label>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Foto del cliente</label>
                                    <div class="image-upload-area" @click="uploadPhoto('photo')">
                                        <img :src="client.photo_url || fileUpload" alt="Foto cliente" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientPhotoFile" accept="image/jpeg, image/png" @change="onFileChange('photo', $event)">
                                    </div>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Documento Frontal</label>
                                    <div class="image-upload-area" @click="uploadPhoto('documentFront')">
                                        <img :src="client.document_front_url || fileUpload" alt="Doc Frontal" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientFrontFile" accept="image/jpeg, image/png" @change="onFileChange('front', $event)">
                                    </div>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Documento Trasero</label>
                                    <div class="image-upload-area" @click="uploadPhoto('documentBack')">
                                        <img :src="client.document_back_url || fileUpload" alt="Doc Trasero" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientBackFile" accept="image/jpeg, image/png" @change="onFileChange('back', $event)">
                                    </div>
                                </div>

                            </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >Guardar Cliente</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";

import {useVuelidate} from '@vuelidate/core';
// 🛑 Importamos email para validación
import {required, email} from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import fileUpload from '@/assets/img/uploadfile.jpg'; // Imagen placeholder
const companyId =localStorage.getItem('companyId');
export default {
    name: "CreateClient", // 🛑 Nombre del componente corregido
    setup:() => ({ v$: useVuelidate() }),
    data() {
        // 🛑 Obtenemos el company ID del localStorage
        const companyId = parseInt(localStorage.getItem('companyId'));

        return {
            fileUpload,
            submitted:false,
            // 🛑 Mapeo de datos para la tabla clients 🛑
            client: {
                nit: null,
                name: null,
                business_name: null,
                email: null,
                phone: null,
                fiscal_address: null,
                commercial_address: null,
                type: 'NATURAL',
                excent: 0, // 0 o 1
                nrc: null,
                // Ubicaciones (FK ID)
                department: null,
                municipality: null,
                // Códigos DTE (guardados en BD)
                department_code: null,
                municipality_code: null,
                department_object: null,
                municipality_object: null,
                // Actividades
                activity_code: null,
                activity_desc: null,
                activity_code_object: null,
                document_type: '13',
                retention_category:0,
                company: companyId || null,
                photo_url: null,
                document_front_url: null,
                document_back_url: null,
            },

            // 🛑 LISTAS DE REFERENCIA DTE 🛑
            clientTypes: [
                { value: 'NATURAL', text: 'Persona Natural' },
                { value: 'JURIDICA', text: 'Persona Jurídica (Contribuyente)' },
                { value: 'EXCLUIDO', text: 'Sujeto Excluido' },
                { value: 'EXCENTA', text: 'ONG' },
            ],
            locations: {
                departments: [],
                municipalities: [],
            },
            documentTypes: [
                { value: '13', text: 'DUI (13)' },
                { value: '36', text: 'NIT (36)' },
            ],
            retentionCategories:[
                { value: 0, text: 'Ninguna' },
                { value: 1, text: 'Grandes Contribuyentes' },
                { value: 2, text: 'Estatal' }
            ],
            economicActivities: [],
        };
    },
    components: {
        ArgonInput,
        ArgonButton,
        ArgonTextarea,
        ArgonSelect,
        ArgonLookup
        // VueDatePicker, etc., eliminados si no se usan
    },
    validations(){
        return{
            client: {
                nit: { required },
                name: { required },
                type: { required },
                email: { email },
                company: { required },
                fiscal_address:{required},
                // NRC es obligatorio para JURIDICA y EXCENTA
                /*nrc: {
                    required: (value) => (this.client.type === 'JURIDICA') ? required(value) : true
                },*/
                department: { required },
                municipality: { required },
            },
        }
    },
    methods:{
        async fetchLocations() {
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };
            const apiURL = this.$store.state.apiURL;

            try {
                const dept='DEPARTAMENTO';
                const mun='MUNICIPIO';
                const depResult = await axios.get(`${apiURL}locations?company=${companyId}&level=${dept}`, config);
                const munResult = await axios.get(`${apiURL}locations?company=${companyId}&level=${mun}`, config);

                this.locations.departments = depResult.data.map(d => ({ value: d.id, text:`${d.code} - ${d.name}`, code: d.code }));
                this.locations.municipalities = munResult.data.map(m => ({ value: m.id, text:`${m.code} - ${m.name}`, code: m.code }));
                console.log(this.locations)

            } catch (error) {
                console.error("Error al cargar ubicaciones:", error);
                Swal.fire('Advertencia', 'No se pudieron cargar las ubicaciones fiscales.', 'warning');
            }
        },

        async fetchEconomicActivities() {
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };
            const apiURL = this.$store.state.apiURL;

            try {
                const result = await axios.get(`${apiURL}activities?company=${companyId}`, config);
                this.economicActivities = result.data.map(a => ({
                    value: a.code,
                    text: `${a.code} - ${a.description}`,
                    description: a.description
                }));
            } catch (error) {
                 console.error("Error al cargar actividades:", error);
            }
        },

        // === MANEJO DE CAMBIOS Y CÓDIGOS DTE ===


        handleActivityLookupChange(selectedObject) {
            if (selectedObject) {
                this.client.activity_code = selectedObject.value;
                this.client.activity_desc = selectedObject.description;
            } else {
                this.client.activity_code = null;
                this.client.activity_desc = null;
            }
        },

        handleDepartmentLookupChange(selectedObject) {
            if (selectedObject) {
                this.client.department = selectedObject.value;
                this.client.department_code = selectedObject.code;
            } else {
                this.client.department = null;
                this.client.department_code = null;
            }
        },

        handleMunicipalityLookupChange(selectedObject) {
            if (selectedObject) {
                this.client.municipality = selectedObject.value;
                this.client.municipality_code = selectedObject.code;
            } else {
                this.client.municipality = null;
                this.client.municipality_code = null;
            }
        },
        // Lógica de carga de fotos (Mantenida, asumiendo que funciona con tu endpoint)
        uploadPhoto(e){
            if(e=='documentFront'){
                this.$refs.clientFrontFile.click();
            }else if(e=='documentBack'){
                this.$refs.clientBackFile.click();
            }else{
                this.$refs.clientPhotoFile.click();
            }
        },
        // Lógica de cambio de archivo (Mantenida)
        onFileChange(type, event){
            let self=this;
            const file = event.target.files[0];
            let formData=new FormData();
            let filename='jpg';
            if(file){
                formData.append('file', file);
                formData.append('fileName', filename);
                axios.post(this.$store.state.fileURL, formData,
                    {
                    headers: {
                        // La autorización puede variar, usando el Bearer si es un servicio de archivos propio
                        "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                    }
                }).then(function(result){
                    // Asume que result.data.url contiene la URL de la imagen subida
                    if(type=='front'){
                        self.client.document_front_url=result.data.url;
                    }else if(type=='back'){
                        self.client.document_back_url=result.data.url;
                    }else{
                        self.client.photo_url=result.data.url;
                    }
                }).catch(err => {
                    console.error("Error al subir archivo:", err);
                    Swal.fire('Error', 'Fallo al subir el archivo.', 'error');
                });
            }
        },

        // LÓGICA DE SUBMIT CORREGIDA (submitClient)
        async submitClient(){
            this.submitted = true;
            this.v$.$touch();

            if(this.v$.$invalid){
                Swal.fire({
                    title: 'Error en validación',
                    text: 'Por favor, revisa los campos obligatorios.',
                    icon:'error',
                    confirmButtonColor:'#0b9257',
                });
                return;
            }
            const currentDep = this.locations.departments.find(d => d.value === this.client.department);
            if (currentDep && !this.client.department_code) {
                 this.client.department_code = currentDep.code;
            }
            const currentMun = this.locations.municipalities.find(m => m.value === this.client.municipality);
            if (currentMun && !this.client.municipality_code) {
                 this.client.municipality_code = currentMun.code;
            }

            // Asegurar que solo el tipo de cliente se almacene correctamente
            const payload = { ...this.client };
            delete payload.department_object;
            delete payload.municipality_object;
            delete payload.activity_code_object;

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Usamos Bearer en la API principal
                }
            };

            try {
                await axios.post(this.$store.state.apiURL + 'clients', payload, config);

                Swal.fire({
                    title: 'Cliente Creado',
                    text: 'Se insertó la información del cliente de manera satisfactoria.',
                    icon:'success',
                    confirmButtonColor:'#0b9257',
                }).then(() => {
                    this.$router.push('/clients');
                });

            } catch (err) {
                console.error('Error al crear cliente:', err.response || err);
                let errorText = 'Fallo al guardar el cliente.';

                if (err.response && err.response.data && err.response.data.error) {
                    errorText = err.response.data.error.includes('Duplicate entry')
                        ? 'Ya existe un cliente con ese NIT para tu compañía.'
                        : err.response.data.error;
                }

                Swal.fire({
                    title: 'Error',
                    text: errorText,
                    icon:'error',
                    confirmButtonColor:'#0b9257',
                });
            }
        },
    },
    async mounted() {
        this.loading = true;
        await Promise.all([
            this.fetchLocations(),
            this.fetchEconomicActivities(),
        ]);
    },
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
</style>